import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { JobRecord, JobStatus } from '../api/api'

type MySearchesState = {
  pastJobs: JobRecord[];
  setJobs: (jobs: JobRecord[]) => void;
};

export const useMySearchesStore = create<MySearchesState>()(
  persist(
    (set, get) => ({
      pastJobs: [],

      setJobs: (jobs) => set({ pastJobs: jobs }),
    }),
    {
      name: "search-form-storage", // key name in localStorage
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export const getJob = (jobID : string | null | undefined) => {
  return useMySearchesStore.getState().pastJobs.find((element) => element.uuid === jobID)
}

export const setJobs = (jobs : JobRecord[]) => {
  useMySearchesStore.setState((state) => ({pastJobs:jobs}));
}

export const addJob = (job : JobRecord) => {
  console.log("New Job:", job);
  console.log("Past Jobs:", useMySearchesStore.getState());
  // Add the new job to the front of the queue of jobs.
  useMySearchesStore.setState((state) => ({pastJobs:[job, ...state.pastJobs]}));
}

export const removeJob = (jobToRemove : JobRecord) => {
  // Make sure a job was passed
  if (jobToRemove && jobToRemove.uuid) {
    let activeJobs = useMySearchesStore.getState().pastJobs;
    let hasThisJobAlready = activeJobs.find((job) => job.uuid === jobToRemove.uuid);
    if(hasThisJobAlready){
      let indexToReplace = activeJobs.indexOf(hasThisJobAlready);
      if(indexToReplace >= 0 && indexToReplace < activeJobs.length){ // Additional sanity check to ensure we are replacing the correct job.
        activeJobs.splice(indexToReplace, 1);
        console.log("Removed Jobs:", activeJobs)
        // Update the jobs to reflect the change of the job which we just updated.
        setJobs(activeJobs);
      }
    }
  }
}

export const updateJob = (jobToUpdate : JobRecord) => {
  let activeJobs = useMySearchesStore.getState().pastJobs;
  let hasThisJobAlready = activeJobs.find((job) => job.uuid === jobToUpdate.uuid);
  if(hasThisJobAlready){
    // We know about this job,
    let indexToReplace = activeJobs.indexOf(hasThisJobAlready);
    if(indexToReplace >= 0 && indexToReplace < activeJobs.length){ // Additional sanity check to ensure we are replacing the correct job.
      activeJobs[indexToReplace] = {
        ...activeJobs[indexToReplace],
        ...jobToUpdate
      };
      console.log("Updated Jobs:", activeJobs)
      // Update the jobs to reflect the change of the job which we just updated.
      setJobs(activeJobs);
    }
  } else {
    // We dont know about this job so add it
    addJob(jobToUpdate);
  }
}

export default useMySearchesStore;